import { AbstractControl } from '@angular/forms';
import { Injectable } from '@angular/core';

@Injectable()
export class FormParser {
  parseNumber(control: AbstractControl): number {
    if (typeof control.value === 'number') {
      return control.value;
    }
    if (typeof control.value === 'string') {
      return Number.parseFloat(control.value.replace(',', '.'));
    }
    throw new Error(`Cannot parse numeric value of ${control}`);
  }
}
